/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/1/22, 3:54 PM
 *
 */

import MemberProfileOverviewTab from 'features/members/components/tabs/MemberProfileOverviewTab/MemberProfileOverviewTab';

export default MemberProfileOverviewTab;
